var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "free-line", style: _vm.line.Style.getStyle() },
    [
      _vm._l(_vm.layout.getLogosByPlacement(_vm.line.Key), function (logo, c) {
        return _c("app-logo", { key: `logo-${c}`, attrs: { logo: logo } })
      }),
      _vm._l(
        _vm.layout.getFreeBlocksByPlacement(_vm.line.Key),
        function (freeBlock, c) {
          return _c("app-free-block", {
            key: `freeBlock-${c}`,
            attrs: { "free-block": freeBlock, lang: _vm.lang },
          })
        }
      ),
      _vm._v(" " + _vm._s(_vm.line.getText(_vm.lang)) + " "),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }